const CARD_STATUS = {
  FAIRLY_FAILED: 'fairlyFailed',
  MOSTLY_FAILED: 'mostlyFailed',
  MEMORIZED: 'memorized',
  IN_PROGRESS: 'inProgress',
  LOCKED: 'locked',
  NOT_SEEN: 'notSeen',
  SKELETON: 'skeleton',
  LOW_PARTICIPATION: 'lowParticipation',
} as const;

type CardStatus = (typeof CARD_STATUS)[keyof typeof CARD_STATUS];

type StudentsFailed = {
  uuid: string;
  firstName?: string | null;
  lastName?: string | null;
};

type StudentsAttempted = {
  uuid: string;
  firstName?: string | null;
  lastName?: string | null;
};

type Card = {
  uuid: string;
  status: CardStatus;
  operand1?: number;
  studentsFailed?: StudentsFailed[];
  studentsAttempted?: StudentsAttempted[];
};

type StudentsCard = {
  uuid: string;
  status: CardStatus;
};

type OperationTable = {
  uuid: string;
  operand2: string;
  cards: Card[];
};

type StudentReport = {
  uuid: string;
  firstName: string;
  lastName: string;
  cards: StudentsCard[];
};

type DeckReport = {
  uuid: string;
  titleTranslationKey: string;
  operator: string;
  isInClassroomCourse: boolean;
  students: StudentReport[];
  operationTables: OperationTable[];
};

function sortDeckReports(reports: DeckReport[]): DeckReport[] {
  return [...reports].sort((a, b) => {
    if (a.operator === '+' && b.operator === 'x') return -1;
    if (a.operator === 'x' && b.operator === '+') return 1;
    return 0;
  });
}

export type {
  CardStatus,
  DeckReport,
  Card as DeckReportCard,
  OperationTable,
  StudentReport,
  StudentsFailed,
  StudentsAttempted,
};

export { CARD_STATUS, sortDeckReports };
